<template>
	<div v-if="!loading">
		<button :disabled="loading || position == null || position <= 1" class="btn btn-sm btn-primary mr-1" @click="updatePosition(-1)">
			˄
		</button>
		<button :disabled="(loading || position >= maxPosition) && maxPosition > 0" class="btn btn-sm btn-primary ml-1" @click="updatePosition(1)" >
			˅
		</button>
	</div>
</template>

<script>
	import axios from "axios";
	import { mapActions, mapMutations } from "vuex";
	export default {
		props: {
			id: {
				type: Number,
				required: true
			},
			position: {
				type: Number,
				required: false,
							
			},
			maxPosition: {
				type: Number,
				required: false,
				default: 1
			}
		},
		data() {
			return {
							newPosition: this.position,
							loading: false
			};
		},
		methods: {
			...mapMutations(["setShowLoadingModal"]),
			...mapActions("axios_mod", ["simpleMutation"]),
			updatePosition(delta) {
				if(this.position == null){
								this.newPosition = this.maxPosition+1;
				}else{
								this.newPosition = this.position + delta;
				}

				this.loading = true;
				this.setShowLoadingModal(true);

				const payload = {
					id: this.id,
					position: this.newPosition
				};

				let data = {
						query: `
								mutation WebshopItemUpdatePosition($id: ID!, $position: Int!) {
										res: WebshopItemUpdatePosition(id: $id, position: $position) 
								}
						`,
						variables: {
							id: parseInt(this.id, 10),
							position: parseInt(this.newPosition, 10)
						}
				};

				this.simpleMutation({data, this_ref: this}).then(() => {
						this.$emit('reloadList');
				});

				this.loading = false;
				this.setShowLoadingModal(false);

			}
		},
		computed: {
			safePosition() { return this.position == null ? "-" : this.position }
		}
	}
</script>